import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Spotify = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <Link to="/projects">
          <motion.button
            whileHover={{ x: -5 }}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            Back to Projects
          </motion.button>
        </Link>

        {/* Project Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Spotify <span className="bg-gradient-to-r from-green-400 to-green-600 bg-clip-text text-transparent">Clone</span>
          </h1>
          <p className="text-xl text-gray-400">
            A feature-rich music streaming platform microfrontend
          </p>
        </motion.div>

        {/* Project Image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="relative rounded-2xl overflow-hidden mb-12 border border-white/10"
        >
          <img
            src="https://images.unsplash.com/photo-1614680376593-902f74cf0d41?w=1200&h=600&fit=crop"
            alt="Spotify Clone"
            className="w-full h-auto"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[rgb(10,10,15)] via-transparent to-transparent" />
        </motion.div>

        {/* Project Details */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-[rgb(15,20,30)] rounded-2xl p-8 border border-white/5 mb-8"
        >
          <h2 className="text-2xl font-bold text-white mb-6">Project Overview</h2>
          <div className="space-y-4 text-gray-400 leading-relaxed">
            <p>
              This Spotify clone is a comprehensive music streaming application built as a microfrontend. 
              It showcases advanced audio handling, real-time updates, and a polished user interface that 
              provides an excellent music listening experience.
            </p>
            <p>
              The application includes features like playlist management, music discovery, social sharing, 
              and advanced audio controls, all built with modern web technologies and best practices.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-white mb-4">Key Features</h3>
            <ul className="grid md:grid-cols-2 gap-3">
              {[
                'Real-time Music Playback',
                'Playlist Creation & Management',
                'Music Discovery & Search',
                'Social Features & Sharing',
                'Advanced Audio Controls',
                'Responsive Design'
              ].map((feature, index) => (
                <li key={index} className="flex items-center gap-2 text-gray-400">
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-white mb-4">Technologies Used</h3>
            <div className="flex flex-wrap gap-2">
              {['React', 'TypeScript', 'Web Audio API', 'Webpack 5', 'Express', 'Socket.io', 'Redis'].map((tech) => (
                <span key={tech} className="px-4 py-2 bg-green-500/10 text-green-400 rounded-lg text-sm font-medium border border-green-500/20">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Coming Soon Notice */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-6 text-center"
        >
          <h3 className="text-xl font-semibold text-blue-400 mb-2">
            🚀 Coming Soon!
          </h3>
          <p className="text-gray-400">
            This microfrontend is currently under development. Check back soon for the live demo!
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Spotify;